//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  auth: false,
  data: () => ({
    filter: null,
  }),
  head: () => ({
    title: 'Zorgverzekering',
  }),
};
